import React from "react";
import Swal from "sweetalert2";
import DynamicLinesDialog from "../../../components/DynamicLinesDialog";
import { HRService } from "../../../config";
import { uploadDocuments } from "../../../data/DocumentManager/documentManagerClient";

const base_url = HRService.uri;

const ManageSurrenderLinesDialog = ({ open, onClose, surrenderData }) => {
    // Form fields configuration - only amountSpent is editable
    const formFields = [
        {
            name: "amountSpent",
            label: "Amount Spent",
            type: "number",
        },
        {
            name: "receiptDocument",
            label: "Supporting Document",
            type: "file",
            required: false,
        },
    ];

    // Table columns configuration
    const columns = [
        { field: "id", headerName: "ID", flex: 0.4 },
        { field: "description", headerName: "Description", flex: 2 },
        { field: "amountRequested", headerName: "Amount Requested", flex: 1, format: "currency" },
        { field: "amountSpent", headerName: "Amount Spent", flex: 1, format: "currency" },
    ];

    // Query configuration
    const queryConfig = {
        name: "imprestSurrenderLinesByImprestId",
        modelName: "imprestSurrenderLines",
        inputField: "surrenderId",
        fields: [
            "id",
            "surrenderId",
            "description",
            "applicationLineId",
            "amountRequested",
            "amountSpent",
            "accountId",
        ],
    };

    // Mutation configuration - only update, no create
    const mutationConfig = {
        update: "updateImprestSurrenderLine",
        modelName: "imprestSurrenderLine",
    };

    // Read-only info to display in edit mode
    const readOnlyInfo = {
        fields: [
            {
                label: "Description",
                getValue: (row) => row.description || "N/A",
            },
            {
                label: "Amount Requested",
                getValue: (row) =>
                    row.amountRequested != null
                        ? new Intl.NumberFormat("en-KE", {
                            style: "currency",
                            currency: "KES",
                        }).format(row.amountRequested)
                        : "N/A",
            },
        ],
    };

    const handleSaveSuccess = async (savedRow, formValues) => {
        if (formValues.receiptDocument) {
            try {
                await uploadDocuments(
                    "/upload/surrender",
                    {
                        surrender_id: surrenderData.id,
                        surrender_line_id: savedRow.id,
                    },
                    formValues.receiptDocument
                );
                Swal.fire("Success", "Document uploaded successfully!", "success");
            } catch (error) {
                console.error("Error uploading document:", error);
                Swal.fire("Upload Failed", "The line was saved but the document upload failed.", "error");
            }
        }
    };

    return (
        <DynamicLinesDialog
            open={open}
            onClose={onClose}
            title="Manage Surrender Lines"
            parentData={surrenderData}
            parentIdField="surrenderId"
            baseUrl={base_url}
            queryConfig={queryConfig}
            mutationConfig={mutationConfig}
            formFields={formFields}
            columns={columns}
            canAdd={false}
            readOnlyInfo={readOnlyInfo}
            onSaveSuccess={handleSaveSuccess}
        />
    );
};

export default ManageSurrenderLinesDialog;
